import { createFileRoute } from '@tanstack/react-router';
import { NetworkConnectivityRequirementsContent } from '../components/documentation/NetworkConnectivityRequirementsContent';
import pageStyles from './network-connectivity-requirements.module.css';

export const Route = createFileRoute('/network-connectivity-requirements')({
  component: NetworkConnectivityRequirementsPublicPage,
});

function NetworkConnectivityRequirementsPublicPage() {
  return (
    <div className={pageStyles.page}>
      <article className={pageStyles.article}>
        <NetworkConnectivityRequirementsContent />
      </article>
    </div>
  );
}
